import { IBuyAndHoldPackageSuccess } from '../types';
import { IBuyAndHoldPackageResponse } from '../../../repositories/billing-service-packages-balancer/v2/buy-and-hold-package';
import { defaultTo } from 'ramda';

export const mapResponse200 = (response: IBuyAndHoldPackageResponse): IBuyAndHoldPackageSuccess => {
  const { heldPayment, message } = response;

  return {
    isSuccess: true,
    transactionId: heldPayment!.transactionId!,
    message: defaultTo(undefined, message),
  };
};
